<template>
  <div class="page-content">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>违规举报处理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/CreditAnalyze' }">违规信息分析</el-breadcrumb-item>
      <el-breadcrumb-item>举报处理结果汇总</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;" label-width="100px">
        <el-form-item label="平台">
          <el-select
            placeholder="请选择"
            v-model="searchform.platform"
            filterable
            size="small"
            clearable
          >
            <el-option
              v-for="(item,i) in plateList"
              :key="i"
              :label="item.dictName"
              :value="item.dictCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称">
          <el-input placeholder="请输入" size="small" v-model="searchform.shopname" clearable></el-input>
        </el-form-item>
        <el-form-item label="处理时间">
          <el-date-picker
            v-model="committime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            :picker-options="pickerOptions"
            :clearable='false'
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="举报ID">
          <el-input placeholder="请输入" size="small" v-model="searchform.reportid" clearable></el-input>
        </el-form-item>
        <el-form-item label="处理结果">
          <el-select v-model="searchform.result" size="small" clearable>
            <el-option v-for="item in allDealReason" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="search-btn" @click="searchTable">查询</el-button>
        </el-form-item>
      </el-form>
    </section>
    <section class="seaerch-wrapper">
      <div style="float: right;width: 100%;margin-bottom: 8px;">
        <el-button size="small" @click="downLoad" type="primary">下载数据</el-button>
        <el-tag type="warning" style="width: calc(100% - 90px);margin-left: 10px;">
          <img src="../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
          <span>本详情数据中仅含有流程处理完结的数据。</span>
        </el-tag>
      </div>
        <!-- <div class="hint_word_orange" style="width:100%;margin-left:10px;">
          <i class="el-icon-warning"></i>
          本详情数据中仅含有流程处理完结的数据。
        </div> -->
      <el-table
        ref="multipleTable"
        header-row-class-name="data-table-header-style"
        :data="tableData"
        style="width: 100%"
        @row-click="rowClick"
        v-loading="dataLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="序号" min-width="5%" type="index"></el-table-column>
        <el-table-column label="违规信息" min-width="45%">
          <template slot-scope="scope">
            <delReportInfo :info="scope.row" :reportTime='false'></delReportInfo>
          </template>
        </el-table-column>
        <el-table-column label="处理结果" min-width="32%">
          <template slot-scope="scope">{{scope.row.result}}</template>
        </el-table-column>
        <el-table-column label="处理时间" min-width="18%">
          <template slot-scope="scope">{{scope.row.flowtime|fullTime}}</template>
        </el-table-column>
      </el-table>
      <Pagination
        @onChange="getReportPage"
        class="pagination"
        :total="totalPage"
        :pagination="pagination"
        style="text-align:right;margin:20px 0;"
      />
      <analyzeRight ref="analyzeRight"></analyzeRight>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import Pagination from "components/pagination/pagination";
import { fetchGet, fetchPost, fetchGetDown } from "@/libs/reqCommon";
import analyzeRight from "./analyzeRight";
import delReportInfo from "../common/delReportInfo";

import { getSinceThreeMonth } from "@/libs/date";

export default {
  data() {
    return {
      searchform: { flowids: "13",type:0,platform:'',result:'' },
      committime: [],
      tableData: [],
      totalPage: 0,
      pagination: {
        size: 10,
        current: 1
      },
      dataLoading:true,
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
    };
  },
  created() {
    this.committime = getSinceThreeMonth();
    this.reqPlateList();
    this.searchTable()
  },
  components: { Pagination, analyzeRight ,delReportInfo},

  computed: {
    ...mapState({
      InstallList: state => state.creditScore.InstallList,
      unauthorizativeType: state => state.creditScore.unauthorizativeType,
    }),
    ...mapGetters(["plateList"]),
    allDealReason(){
      let result=['品牌方管理人员超时未处理，系统自动结案']
      return [...this.InstallList,...result,...this.unauthorizativeType]
    }
  },
  methods: {
    getRecentDate(picker,n){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.committime[0] = this.$options.filters["fullTime"](end);
        this.committime[1] = this.$options.filters["fullTime"](end);
      } else {
        this.committime[0] = this.$options.filters["fullTime"](start);
        this.committime[1] = this.$options.filters["fullTime"](end);
      }
    },
    ...mapActions(["reqPlateList", "getById"]),
    searchTable() {
      this.pagination = {
        current: 1,
        size: 10
      };
      this.searchform.starttime = this.committime
        ? this.committime[0].slice(0, 10)
        : "";
      this.searchform.endtime = this.committime
        ? this.committime[1].slice(0, 10)
        : "";
      this.getReportPage();
    },
    downLoad() {
      let data = this.searchform;
      fetchGetDown("hcm/hcmReport/exportExcel", data, "举报处理结果汇总");
    },
    async rowClick(row) {
      await this.getById(row.reportid);
      this.$refs.analyzeRight.ifshow = true;
        this.$refs.analyzeRight.activeName = 'first';
    },
    getReportPage() {
       this.dataLoading=true
      let data = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.size,
        ...this.searchform,
      };
      fetchGet("hcm/hcmReport/getReportPage", data).then(res => {
         this.dataLoading=false
        if (res.status === "10000") {
          this.tableData = res.data.content;
          this.totalPage = res.data.totalElements;
        }
      }).catch(()=>{
         this.dataLoading=false
      })
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";
@import "src/style/tableCommon";
</style>
